import { render, staticRenderFns } from "./SaidaItensEditModal.vue?vue&type=template&id=1191fec4&scoped=true"
import script from "./SaidaItensEditModal.vue?vue&type=script&lang=js"
export * from "./SaidaItensEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191fec4",
  null
  
)

export default component.exports